export default "__VITE_ASSET__xKWRowcD__"